import BaseResource from './index'

export default class UnionJurisdictionResource extends BaseResource {
    static endpoint = '/oasis/restv3/unionJurisdictions'
}
